module.exports = __webpack_public_path__ + "img/dowloadBg.ab31015b.png";